import styled from 'styled-components';
import { themeGet, getBackgroundColor, getTextColor, getBorderColor } from '@magalu/stereo-ui-styles';
export const Container = styled.div`
  display: flex;
  align-items: center;
`;
export const Title = styled.p`
  margin-right: 5px;
  color: ${props => getTextColor('scratched')(props)};
`;
export const FilterBar = styled.div`
  background-color: ${props => getBackgroundColor('lighter')(props)};
  color: ${props => getTextColor('lightest')(props)};
  height: 2em;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  padding: 25px 0;
  border-bottom: 1px solid ${props => getBorderColor('light')(props)};
`;
export const Backward = styled.span`
  padding: ${props => themeGet('fontSizes.3')(props)}px;
  cursor: pointer;
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  fill: ${props => getTextColor('scratched')(props)};
`;
export const TitleSideCard = styled(Backward)`
  color: ${props => getTextColor('base')(props)};
`;
export const Clear = styled(Backward)`
  color: ${props => props.count >= 1 ? themeGet('palette.primary.base') : getTextColor('light')};
`;